import ReportFolder from 'modules/reports/models/ReportFolder'
import React, {useContext} from 'react'

type ContextProps = {
  folderId: number
  onSelect: (folder: ReportFolder) => any
  onCreate: (folder: ReportFolder) => any
  onEdit: (folder: ReportFolder) => any
  onDelete: (folder: ReportFolder) => any
}

const ReportsFolderSidebarContext = React.createContext<ContextProps>(null as any)

export default ReportsFolderSidebarContext

export function useReportsFolderSidebarContext() {
  return useContext(ReportsFolderSidebarContext)
}
